/**
 * This accepts date ISO as an input and returns Date object with hours, min, sec, and ms set to 0
 * @param dateString
 * @returns {Date}
 */
export default dateString => {
  const date = new Date(dateString)
  date.setHours(0, 0, 0, 0)
  return date
}
